// removed by extract-text-webpack-plugin
module.exports = {"arrow-container":"CardComparisonRow__arrow-container","arrowContainer":"CardComparisonRow__arrow-container","cell":"CardComparisonRow__cell","left":"CardComparisonRow__left","right":"CardComparisonRow__right","row":"CardComparisonRow__row"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/components/CardComparisonRow/CardComparisonRow.mobile.css
// module id = 1311
// module chunks = 8